import { basketActions, purchaseActions, addressActions } from '../../actions/transactions';

export default function transactions( state, action ) {
    if( !state ) {
        return {
            products: [],
            packages: [],
            basket: { products: [], packages: [], fetched: false },
            addresses: [],
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case basketActions.actions.SET_BASKET: return setBasket( newState, action.basket );
        case purchaseActions.actions.SET_PACKAGES: return setPackages( newState, action.packages );
        case purchaseActions.actions.SET_PRODUCTS: return setProducts( newState, action.products );
        case basketActions.actions.SET_ADD_PRODUCT_TO_BASKET: return addProductToBasket( newState, action.product );
        case basketActions.actions.SET_ADD_PACKAGE_TO_BASKET: return addPackageToBasket( newState, action.package );
        case basketActions.actions.SET_REMOVE_PRODUCT_FROM_BASKET: return removeProductFromBasket( newState, action.productId );
        case basketActions.actions.SET_REMOVE_PACKAGE_FROM_BASKET: return removePackageFromBasket( newState, action.packageId );
        case basketActions.actions.SET_CLEAR_BASKET: return clearBasket( newState );
        case basketActions.actions.SET_PRICE_FOR_BASKET: return setBasketPrice( newState, action );
        case addressActions.actions.SET_PERSON_ADDRESSES: return setPersonAddresses( newState, action.addresses );
        case addressActions.actions.ADD_PERSON_ADDRESS: return addPersonAddress( newState, action.address );
        case addressActions.actions.SET_PERSON_BILLING_ADDRESS: return setPersonBillingAddress( newState, action.addressId );
        case basketActions.actions.SET_PAYMENT_URL: return setPaymentUrl( newState, action.url );
        case purchaseActions.actions.REISSUE_PERMISSIONS: return setPermissions( newState, action.permissions, action.token );
        case addressActions.actions.RESET_ADDRESS: return resetAddress( newState );
        case purchaseActions.actions.SET_PROMOTIONS: return setPromotionPrices( newState, action );
        case purchaseActions.actions.ADDED_PROMOTION_TO_BASKET: return addedPromotionToBasket( newState, action.promotionAddedToBasket );
        default: return newState;
    }
}

function setBasket( newState, basket ) {
    const _basket = { ...newState.basket };
    _basket.fetched = true;
    if ( basket.transaction_items ) {
        const packages = [];
        const products = [];

        basket.transaction_items.forEach( ( item ) => {

            if ( item.package_id ) {
                packages.push( { id: item.package_id } );
            }

            if ( item.product_permission_id ) {
                products.push( { id: item.product_permission_id } );
            }
        } );

        _basket.packages = packages;
        _basket.products = products;
    }
    newState.basket = _basket;
    return newState;
}

function setPackages( newState, packages ) {
    newState.packages = packages;

    return newState;
}

function setProducts( newState, products ) {
    newState.products = products;
    return newState;
}

function addProductToBasket( newState, productId ) {
    const basket = { ...newState.basket };
    const products = [ ...basket.products ];

    const promotionalProduct = [ ...newState.promotional_products ];
    const productPromotion = { ...promotionalProduct[0] };

    products.push( { id: productId } );
    basket.products = products;
    newState.product_promotion_price = productPromotion.promotional_price;
    newState.product_promotion_id = productPromotion.product_id;
    newState.basket = basket;

    return newState;
}

function addPackageToBasket( newState, packageId ) {
    const basket = { ...newState.basket };
    const packages = [ ...basket.packages ];
    const promotionalPackage = [ ...newState.promotional_packages ];
    const packagePromotion = { ...promotionalPackage[0] };
    const packageAlreadyInBasket = promotionalPackage.length ? basket.packages.filter( basket => basket.id === promotionalPackage[0].package_id ) : [];

    if( packageAlreadyInBasket.length === 0 ) {
        packages.push( { id: packageId } );
    }

    basket.packages = packages;
    newState.package_promotion_price = packagePromotion.promotional_price;
    newState.package_promotion_id = packagePromotion.package_id;
    newState.basket = basket;
    return newState;
}

function removeProductFromBasket( newState, productId ) {
    const basket = { ...newState.basket };
    const products = [ ...basket.products ];

    basket.products = products.filter( product => product.id !== productId );

    newState.basket = basket;

    return newState;
}

function removePackageFromBasket( newState, packageId ) {
    const basket = { ...newState.basket };
    const packages = [ ...basket.packages ];

    basket.packages = packages.filter( packageItem => packageItem.id !== packageId );

    newState.basket = basket;

    return newState;
}

function clearBasket( newState ) {
    const basket = { ...newState.basket };
    let products = [ ...basket.products ];
    let packages = [ ...basket.packages ];

    products = [];
    packages = [];

    basket.products = products;
    basket.packages = packages;

    newState.basket = basket;

    return newState;
}

function setPersonAddresses( newState, addresses ) {
    newState.addresses = addresses;

    return newState;
}

function addPersonAddress( newState, address ) {
    const addresses = [ ...newState.addresses ];

    address.primary_billing_address = 1;

    addresses.push( address );

    newState.addresses = addresses;

    return newState;
}

function setPersonBillingAddress( newState, addressId ) {
    const addresses = newState.addresses.map( ( address ) => {
        address.primary_billing_address = false;
        return address;
    } );

    const address = addresses.filter( a => a.id === addressId )[ 0 ];

    address.primary_billing_address = true;

    newState.addresses = addresses;

    return newState;
}

function setPaymentUrl( newState, url ) {
    newState.basket.url = url;

    return newState;
}

function setPermissions( newState, permissions, token ) {
    localStorage.permissions = JSON.stringify( permissions );
    localStorage.token = token;

    return newState;
}

function resetAddress( newState ) {
    newState.addresses = [];
    
    return newState;
}

function setPromotionPrices( newState, action ) {
    const _packages = [ ...action.packages ],
          _products = [ ...action.products ];

    const currentPackagePromotions = _packages.filter( _package => _package.base_price !== _package.promotional_price );
    const currentProductPromotions = _products.filter( _product => _product.base_price !== _product.promotional_price );

    newState.all_packages = _packages;
    newState.all_products = _products;
    newState.promotional_packages = currentPackagePromotions;
    newState.promotional_products = currentProductPromotions;

    return newState;
}

function addedPromotionToBasket( newState, promotionAddedToBasket ) {
    let _promotionAddedToBasket = promotionAddedToBasket;

    _promotionAddedToBasket = true;

    newState.promotionAdded = _promotionAddedToBasket;

    return newState;
}


function setBasketPrice( newState, action ) {
    newState.basket.total = action.total;
    newState.basket.VATApplied = action.VATApplied;
    return newState;
}




// WEBPACK FOOTER //
// src/client/reducers/transactions/transactions.js